import ApiProvider from 'libs/providers/api/api.provider';
import { Observable, of } from 'rxjs';
import brands from '../../../../assets/data/brands.json';
import RequestProvider from 'domains/core-base/request/providers/request-provider';
import { AjaxResponse } from 'rxjs/ajax';
import env from 'libs/constants/env';
import VehicleMapping from '../mappings/vehicle-mapping';
import BrandMapping from '../mappings/brand-mapping';
import ModelMapping from '../mappings/model-mapping';
import SumInsuredMapping from '../mappings/sum-insured-dto';
import { VehicleModelDto } from '../dtos/vehicle-model-dto';

class VehicleProvider {
  static _provider: ApiProvider = new ApiProvider();

  static queryByPlate = (params: {
    authorization: string;
    plate: string;
    recaptcha: string;
  }): Observable<AjaxResponse<any>> => {
    return this._provider.get(`${env.CONTEXT_PATH}/vehiculos/${params.plate}`, {
      Authorization: params.authorization,
      'Transaccion-Id': env.DEFAULT_REQUEST_ID,
      'g-recaptcha-response': params.recaptcha,
    });
  };

  static getVehicleBrands(): Observable<any> {
    return of(brands);
  }

  static getVehicleModels = (params: {
    brandCode: string;
    authorization: string;
    recaptcha: string;
  }): Observable<AjaxResponse<VehicleModelDto[]>> => {
    const request = RequestProvider.getInstance();
    return this._provider.get(
      `${env.CONTEXT_PATH}/vehiculos/marcas/${params.brandCode}/obtener-modelos`,
      {
        Authorization: params.authorization,
        'Transaccion-Id': request.getRequestId(),
        'g-recaptcha-response': params.recaptcha,
      },
    );
  };

  static getSumInsured = (params: {
    brandCode: string;
    apesegBrandCode: string;
    modelCode: string;
    apesegModelCode: string;
    year: string;
    authorization: string;
    recaptcha: string;
  }): Observable<AjaxResponse<any>> => {
    return this._provider.post(
      `${env.CONTEXT_PATH}/vehiculos/obtener-suma-asegurada`,
      {
        codigoMarca: params.brandCode,
        codigoModelo: params.modelCode,
        anioVehiculo: params.year,
        codigoMarcaApeSeg: params.apesegBrandCode,
        codigoModeloApeSeg: params.apesegModelCode
      },
      {
        Authorization: params.authorization,
        'Transaccion-Id': env.DEFAULT_REQUEST_ID,
        'g-recaptcha-response': params.recaptcha,
      },
    );
  };

  static create = (params: any): Observable<AjaxResponse<any>> => {
    const request = RequestProvider.getInstance();
    const data = new VehicleMapping(
      new BrandMapping(),
      new ModelMapping(),
      new SumInsuredMapping(),
    ).formatCreateVehicleRequest(params.vehicle);
    return this._provider.post(
      `${env.CONTEXT_PATH}/vehiculos`,
      {
        identificadorSolicitud: request.getRequestId(),
        ...data,
      },
      {
        Authorization: params.authorization,
        'Transaccion-Id': env.DEFAULT_REQUEST_ID,
        'g-recaptcha-response': params.recaptcha,
      },
    );
  };

  static update = (params: {
    id: string;
    authorization: string;
    sumInsuredSelected?: number | any;
    engineSerialNumber?: string;
    chassisSerialNumber?: string;
    recaptcha: string;
  }): Observable<AjaxResponse<any>> => {
    const request = RequestProvider.getInstance();
    const { authorization, id, ...body } = params;
    const data = new VehicleMapping(
      new BrandMapping(),
      new ModelMapping(),
      new SumInsuredMapping(),
    ).formatPatchVehicleRequest({ id, ...body });
    return this._provider.patch(
      `${env.CONTEXT_PATH}/vehiculos/${id}`,
      {
        ...data,
      },
      {
        Authorization: authorization,
        'Transaccion-Id': request.getRequestId(),
        'g-recaptcha-response': params.recaptcha,
      },
    );
  };

  static readonly getChineseVehicle = (params: {
    id: string;
    authorization: string;
    recaptcha: string;
  }): Observable<AjaxResponse<any>> => {
    return this._provider.get(
      `${env.CONTEXT_PATH}/vehiculos/${params.id}/validar-modelo`,
      {
        Authorization: params.authorization,
        'Transaccion-Id': env.DEFAULT_REQUEST_ID,
        'g-recaptcha-response': params.recaptcha,
      },
    );
  };
}
export default VehicleProvider;
